import { getCommaSeparatedObjectValues } from '../../../utils';

export const getAddressSubmitEventForFieldValidation = ({
  newAddress,
  isEditForm
}) => {
  let formSubmitVal = 'Add Billing Address';
  let formContent = 'Address Added';
  if (isEditForm === true) {
    formSubmitVal = 'Edit Billing Address';
    formContent = 'Address Updated';
  }
  if (isEditForm === 'inlineAddress') {
    formSubmitVal = 'Billing Address Submit';
    formContent = 'Address Submitted';
  }
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: formSubmitVal,
    formContent: formContent,
    formContent2: 'AVI, none',
    formStatus: 'fail',
    formLocation: '',
    formFieldCausingError: getCommaSeparatedObjectValues(newAddress?.errors)
  };
};
